import { GetStartedTaskStatus } from '../store/schema/GetStartedTaskStatus';
import { getStore } from '../store/store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function getPendingGetStartedTaskCount(): number {
    if (getUserConfiguration().SessionSettings.IsShadowMailbox) {
        return 0;
    }

    const store = getStore();

    if (store.tasks) {
        return Object.keys(store.tasks).filter(
            key => store.tasks[key].status === GetStartedTaskStatus.Pending
        ).length;
    }

    return -1;
}
